import genererCampagne from '@/services/import/campagne/genererCampagne';
import genererTag from '@/services/parametrage/generation/genererTag';
import completeParametrageGeneriqueNonExistant from '@/services/import/General/parametrage/completeParametrageGeneriqueNonExistant';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { createAll as createAllCampagne } from '@/api/campagne/index';
import { columns } from '@/services/import/campagne/templateCampagne';
import { extraireLibelles } from '@/services/import/General/general';
import i18n from '@/i18n/index';
import gestionParametre from '@/services/import/General/gestionParametre';
import moment from 'moment';

export function ErrorCampagneTranslate(errors) {
  if (!errors || !Array.isArray(errors)) return [];
  return errors.map(error => {
    if (error.endsWith('_IS_REQUIRED')) {
      return i18n.t('importationCampagne.errors.requiredPropertie', { label: error.split('_')[0] });
    }
    if (error.includes('_MAX_LENGTH_')) {
      return i18n.t('importationCampagne.errors.maxLengthPropertie', { label: error.split('_')[0], length: error.split('_')[error.split('_').length - 1] });
    }
    if (error.includes('_MARQUE_NOT_FOUND')) {
      return i18n.t('importationCampagne.errors.marqueNotFound', { name: error.split('_')[0] });
    }
    if (error.includes('_START_DATE_GREATER_THAN_END_DATE')) {
      return i18n.t('importationCampagne.errors.dateDebutGreaterDateFin', { libelle: error.split('_')[0] });
    }
    switch (error) {
      case 'TAGS_MUST_BE_ENCLOSED_IN_QUOTES_AND_SEPARATED_BY_COMMAS':
        return i18n.t('importationCampagne.errors.tagMustBeEnclusedInQuotesAndSeparatedByCommas');
      case 'DATE_DEBUT_WRONG_FORMAT':
        return i18n.t('importationCampagne.errors.wrongFormatDateDebut');
      case 'DATE_FIN_WRONG_FORMAT':
        return i18n.t('importationCampagne.errors.wrongFormatDateFin');
      default:
        return 'Un problème est survenu';
    }
  }).join(' - ');
}

function isDateObject(date) {
  return !!date && date instanceof Date;
}
function isValidDate(date) {
  if (!date && isDateObject(date)) return false;
  return moment(date, ['DD/MM/YYYY', 'DD-MM-YYYY']).isValid();
}

function validationLigne(ligne, marques) {
  const error = {
    numLigne: ligne.numLigne,
    errors: [],
  };
  const marque = marques.find(m => m.libelle.toLowerCase() === ligne.marqueId?.toLowerCase());
  if (ligne.marqueId && !marque) error.errors.push(`${ligne.marqueId}_MARQUE_NOT_FOUND`);
  columns.forEach(column => {
    const columnErrors = column.checkValue(ligne[column.key]);
    if (columnErrors.length > 0) error.errors = error.errors.concat(columnErrors);
  });

  if (ligne.dateDebut !== undefined && !isValidDate(ligne.dateDebut)) {
    error.errors.push('DATE_DEBUT_WRONG_FORMAT');
  }

  if (ligne.dateFin !== undefined && !isValidDate(ligne.dateFin)) {
    error.errors.push('DATE_FIN_WRONG_FORMAT');
  }

  if (isValidDate(ligne.dateDebut)
    && isValidDate(ligne.dateFin)
    && moment(ligne.dateDebut, ['DD/MM/YYYY', 'DD-MM-YYYY']).isAfter(moment(ligne.dateFin, ['DD/MM/YYYY', 'DD-MM-YYYY']))
  ) {
    error.errors.push(`${ligne.libelle}_START_DATE_GREATER_THAN_END_DATE`);
  }

  if (ligne.tags?.trim()) {
    ligne.tags = ligne.tags
      .trim().replace(/,$/, '')
      .trim().replace(/^,/, '')
      .trim();
    const regex = /^"([^"]+")(,"[^"]+")*$/;
    if (!regex.test(ligne.tags)) {
      error.errors.push('TAGS_MUST_BE_ENCLOSED_IN_QUOTES_AND_SEPARATED_BY_COMMAS');
    }
  }

  if (error.errors.length > 0) throw error;
}

export async function makeCampagneGenerated(file) {
  const lignes = file[0];
  const campagnes = [];
  const errors = [];
  const tags = [];
  const marquesExistant = await gestionParametre('commun/Marque');
  // saut de la premiere vu qu'on a 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    try {
      validationLigne(lignes[i], marquesExistant);
      if (lignes[i]?.tags) {
        lignes[i].tags = extraireLibelles(lignes[i].tags);
        tags.push(...lignes[i].tags);
      }
    } catch (e) {
      errors.push(e);
    }
  }
  if (errors.length > 0) {
    errors.unshift({ total: lignes.length - 1, totalErrors: errors.length });
    throw errors;
  }

  await completeParametrageGeneriqueNonExistant(PARAMETRES_KEYS.tag, tags, genererTag());

  // saut de la premiere vu qu'on 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    const campagne = genererCampagne(lignes[i], marquesExistant);
    campagnes.push(campagne);
  }

  return campagnes;
}

export async function makeCampagneImport(campagnes) {
  const errors = [];
  const batch = 200;
  for (let i = 0; i < campagnes.length; i += 200) {
    try {
      const campagnesToCreate = campagnes.slice(i, i + batch);
      // eslint-disable-next-line no-await-in-loop
      await createAllCampagne(campagnesToCreate);
    } catch (e) {
      errors.push({ error: e });
    }
  }
  if (errors.length > 0) throw errors;
}
